import { translate } from '@fiverr-private/i18n-react';
import { numberFormat } from '@fiverr-private/localization';
import { TemporalUnit } from '../../types';
import { HOURS_IN_DAY } from './constants';

/**
 * Returns text representation of the response time given
 * response time in the past hours as a number value.
 *
 * @param {number} responseTimeInHrs The response time in hours
 * @returns {string}
 */
export const getResponseTimeTextValue = (responseTimeInHrs) => {
    try {
        const { count, unit } = parseResponseTime(responseTimeInHrs);

        const params = {
            count: numberFormat({ value: count })
        };

        return translate(`send_message.time.avg_response_time_value.${unit}`, { params });
    } catch (error) {
        return undefined;
    }
};

/**
 * given response time in hours, we return the time representation in day or week format.
 * parsed in days or weeks in case seller takes too much time to response
 *
 * @param {number} responseTimeInHrs The average response time in hours
 * @returns {{unit: string, count: number}}
 */
const parseResponseTime = (responseTimeInHrs) => {
    if (!(Number(responseTimeInHrs) > 0)) {
        throw new Error(`Response time of ${responseTimeInHrs} is invalid`);
    }

    if (responseTimeInHrs >= HOURS_IN_DAY * 7) {
        return {
            unit: TemporalUnit.WEEK,
            count: responseTimeInHrs / (HOURS_IN_DAY * 7)
        };
    }

    if (responseTimeInHrs >= HOURS_IN_DAY * 2) {
        return {
            unit: TemporalUnit.DAY,
            count: Math.floor(responseTimeInHrs / HOURS_IN_DAY)
        };
    }

    if (responseTimeInHrs >= HOURS_IN_DAY) {
        return {
            unit: TemporalUnit.DAY,
            count: 1
        };
    }

    return {
        unit: TemporalUnit.HOUR,
        count: responseTimeInHrs
    };
};
